import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fgbcl-card-link-success-content',
  templateUrl: './card-link-success-content.component.html',
  styleUrls: ['./card-link-success-content.component.scss'],
})
export class CardLinkSuccessContentComponent implements OnInit {
  @Input() googleIconName1: string = 'credit_card';
  @Input() googleIconName2: string = 'star';
  @Input() googleIconName3: string = 'emoji_events';
  @Input() routerLink: string = '/affiliate/alloffers';
  constructor() {}

  ngOnInit(): void {}
}
